module.exports = __webpack_public_path__ + "images/ciemny.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/ciemny.jpg
// module id = 25
// module chunks = 0